export const GET_PLAN_ISASUB_ABORTED = 'GET_PLAN_ISASUB_ABORTED';
export const GET_PLAN_ISASUB_REQUESTED = 'GET_PLAN_ISASUB_REQUESTED';
export const GET_PLAN_ISASUB_COMPLETED = 'GET_PLAN_ISASUB_COMPLETED';
export const GET_PLAN_ISASUB_FAILED = 'GET_PLAN_ISASUB_FAILED';
export const RESET_PLAN_ISASUB_REQUESTED = 'RESET_PLAN_ISASUB_REQUESTED';
export const RESET_PLAN_ISASUB_COMPLETED = 'RESET_PLAN_ISASUB_COMPLETED';
